// extracted by mini-css-extract-plugin
export default {"templatesManager":"templates-manager_templatesManager__3j0cI","emptyState":"templates-manager_emptyState__wQ6Yg","emptyStateMessage":"templates-manager_emptyStateMessage__3fNCU"};